export default __webpack_public_path__ + "static/media/txt_judging.aaf04ef6.svg";